export default "__VITE_ASSET__CDe1cwVR__"